import { render, staticRenderFns } from "./mapWorld.vue?vue&type=template&id=4229e13c&scoped=true&"
import script from "./mapWorld.vue?vue&type=script&lang=js&"
export * from "./mapWorld.vue?vue&type=script&lang=js&"
import style0 from "./mapWorld.vue?vue&type=style&index=0&id=4229e13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4229e13c",
  null
  
)

export default component.exports